import { IconChevronRight16 } from '@cian/ui-kit/icons';
import React, { FC } from 'react';
import { POPULAR_LIST_TITLES } from '../../constants/popularListTitles';
import { ITopGroup } from '../../types/top_three';
import { Container } from '../Container';
import { Link } from '../Link';
import { PopularItem } from '../PopularItem';
import { getUrlByRegion } from './helpers';
import styles from './PopularList.css';

type TPopularList = { items: ITopGroup[]; region?: number };

export const PopularList: FC<TPopularList> = ({ items, region }) => {
  return (
    <Container dataName="PopularList">
      <h2 className={styles['title']}>Популярные объявления</h2>
      {items.map(({ id, offers }) => {
        const { text, url } = POPULAR_LIST_TITLES[id as keyof typeof POPULAR_LIST_TITLES];

        return (
          <div className={styles['list-container']} key={id}>
            <Link href={getUrlByRegion(url, region)}>
              <div className={styles['list-title']}>
                {text}
                <div className={styles['arrow-icon']}>
                  <IconChevronRight16 color="superblack_100" />
                </div>
              </div>
            </Link>
            <div className={styles['list']}>
              {offers.slice(0, 3).map(props => (
                <PopularItem {...props} key={props.url} />
              ))}
            </div>
          </div>
        );
      })}
    </Container>
  );
};
